import { injectable } from 'inversify';
import { Permission } from '../../constants/Permission';

@injectable()
export abstract class PermissionsProvider {
  abstract hasPermission(permission: Permission): boolean;
}
